export default "__VITE_ASSET__BKFSgAT___"